import React from 'react';

const StatusIndicator = ({ status = 'Active', color = 'green', className = '' }) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <div
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: color,
          marginRight: 5, // Space between dot and text
        }}
      ></div>
      <span>{status}</span>
    </div>
  );
};

export default StatusIndicator;
